import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const WaterlowDetail = ({ item }) => {
    return (
        <>
            {item.confirm.status && (
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Status</h5>
                    </div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "#0abb9d", color: "white" }} className="text-center" colSpan="4">
                                    <span className="w-100">Confirmed</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Confirmed By</strong>
                                </td>
                                <td>
                                    <StaffProfileCard item={item.confirm.author} />
                                </td>
                                <td style={{ backgroundColor: "aliceblue" }}>
                                    <strong>Confirmed Date & Time</strong>
                                </td>
                                <td>
                                    <span className="text-primary">{cleanDate(item.confirm.datetime, false, false)}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            {!item.confirm.status && (
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Status</h5>
                    </div>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ color: "white" }} className="text-center bg-danger" colSpan="4">
                                    <span className="w-100">Unconfirmed</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Sex and Age</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}></td>
                            <td style={{ backgroundColor: "aliceblue", width: "75%" }}></td>
                            <td style={{ backgroundColor: "aliceblue", width: "10%" }}>
                                <strong>Score</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue" }}>
                                <strong>Sex*</strong>
                            </td>
                            <td>
                                <span className="text-primary">{item.sex}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue" }}>
                                <strong>Age*</strong>
                            </td>
                            <td>
                                <span className="text-primary">{item.age}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Skin Type and Visual Risk Areas</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Skin*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.skin}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Build/Weight for Height</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>BMI range*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.bmiRange}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Malnutrition Screening Tool</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>A - Has the Patient lost weight recently?*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.malNutrition.a}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>B - Weight Loss*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.malNutrition.b}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>C - Patient eating poorly or lack of Appetite?*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.malNutrition.c}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Continence</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Continence Score*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.continence}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Mobility</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Mobility Score*</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.mobility}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Special Risk</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Tissue Malnutrition</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.specialRisk.tissue}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Neurological Deficit</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <ul className="text-primary">
                                    {item.specialRisk.neurology.map((i, idx) => (
                                        <li key={idx}>{i}</li>
                                    ))}
                                </ul>
                            </td>
                            <td></td>
                        </tr>

                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Major Surgery or Trauma</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.specialRisk.major}</span>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                <strong>Medication</strong>
                            </td>
                            <td style={{ width: "75%" }}>
                                <span className="text-primary">{item.specialRisk.medication}</span>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};
export default WaterlowDetail;
